import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { DataEventService } from '../../../services/data-event.service';

@Component({
    selector: '.o-featured'
})
export class FeaturedComponent extends ComponentBase<HTMLElement> {

    public constructor(node: HTMLElement, private _dataEventService: DataEventService) {
        super(node);
    }

    public onInit(): void {
    }

    @ClickListener('a')
    public onViewContent(event: MouseEvent): void {
        const item: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;        
        this._dataEventService.viewContent(new URL(item.href).pathname);
    }
}